import { Styles } from './styles';

export const defaultStyles: Styles = {
  control: {
    root: 'control',
    input: 'input',
  },
  verticalLayout: {
    root: 'vertical-layout',
    item: 'vertical-layout-item',
  },
  horizontalLayout: {
    root: 'horizontal-layout',
    item: 'horizontal-layout-item',
  },
  group: {
    root: 'group',
    label: 'group-label',
    item: 'group-item',
    bare: 'group-bare',
    alignLeft: 'group-align-left',
  },
  arrayList: {
    root: 'array-list',
    toolbar: 'array-list-toolbar',
    validationIcon: 'array-list-validation',
    addButton: 'array-list-add',
    label: 'array-list-label',
    noData: 'array-list-no-data',
    item: 'array-list-item',
    itemHeader: 'array-list-item-header',
    itemLabel: 'array-list-item-label',
    itemContent: 'array-list-item-content',
    itemMoveUp: 'array-list-item-move-up',
    itemMoveDown: 'array-list-item-move-down',
    itemDelete: 'array-list-item-delete',
  },
  listWithDetail: {
    root: 'list-with-detail',
    toolbar: 'list-with-detail-toolbar',
    addButton: 'list-with-detail-add',
    label: 'list-with-detail-label',
    noData: 'list-with-detail-no-data',
    item: 'list-with-detail-item',
    itemLabel: 'list-with-detail-item-label',
    itemContent: 'list-with-detail-item-content',
    itemMoveUp: 'list-with-detail-item-move-up',
    itemMoveDown: 'list-with-detail-item-move-down',
    itemDelete: 'list-with-detail-item-delete',
  },
  label: {
    root: 'label-element',
  },
  categorization: {
    root: 'categorization',
  },
};
